export default {
  user: sessionStorage.getItem('user') ? JSON.parse(sessionStorage.getItem('user')) : null
}



// WEBPACK FOOTER //
// ./src/store/modules/user/state.js